import {put,takeLatest,call} from 'redux-saga/effects'
import * as superUserService from "../../../services/superUserService"
import {
    GET_SUPERUSER,
    GET_SUPERUSER_SUCCESS,
    GET_SUPERUSER_ERROR
}
    from "../../actions/superuser"

function* getSuperUserSaga(action) {
    try {
        const data=yield call(superUserService.GetSuperUser,action.payload)
        yield put({
            type: GET_SUPERUSER_SUCCESS,
            payload: data
        })

    } catch(error) {
        yield put({
            type: GET_SUPERUSER_ERROR,error: error.data
        })
    }
}


export function* getSuperUserSagaWatcher() {
    yield takeLatest(GET_SUPERUSER,getSuperUserSaga)
}